// import React, { useState } from "react";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Navigation, Pagination, Autoplay } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/navigation";
// import "swiper/css/pagination";
// import "./EventsSection.css"; // Import CSS

// const EventsSection = ({ cards }) => {
//   const [hoveredCard, setHoveredCard] = useState(null);

//   return (
//     <section className="events-section">
//       <h2>Upcoming Events and Reunions</h2>
     
//         <Swiper
//           modules={[Navigation, Pagination, Autoplay]}
//           spaceBetween={50}
//           slidesPerView={5}
//           navigation
//           pagination={{ clickable: true }}
//           autoplay={{ delay: 3000, disableOnInteraction: false }}
//           loop={true}
//           className="event-swiper"
//         >
//           {cards.map((card, index) => (
//             <SwiperSlide key={card.id}>
//               <div
//                 className={`events-card ${hoveredCard === card.id ? "active" : ""}`}
//                 onMouseEnter={() => setHoveredCard(card.id)}
//                 onMouseLeave={() => setHoveredCard(null)}
//               >
//                 <img src={card.image} alt={card.title} />
//                 <h3>{card.title}</h3>
//                 <p>{card.description}</p>
//               </div>
//             </SwiperSlide>
//           ))}
//         </Swiper>
//     </section>
//   );
// };

// export default EventsSection;

import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./EventsSection.css"; // Import CSS

const EventsSection = ({ cards }) => {
  const [hoveredCard, setHoveredCard] = useState(null);

  return (
    <section className="events-section">
      <h2>Previously Conducted Events</h2>

      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={220} // Adjusted spacing for better separation
        slidesPerView={2} // Shows 4 cards per view
        breakpoints={{
          1400: { slidesPerView: 5, spaceBetween: 30 },
          1200: { slidesPerView: 4, spaceBetween: 10 },
          992: { slidesPerView: 3, spaceBetween: 60 },
          768: { slidesPerView: 2, spaceBetween: 40 },
          490: { slidesPerView: 1, spaceBetween: 30 },  
          0: { slidesPerView: 1, spaceBetween: 20 },    
        }}
        
        navigation
        pagination={{ clickable: true }}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        loop={true}
        className="event-swiper"
      >
        {cards.map((card) => (
          <SwiperSlide key={card.id}>
          <div className="event-slide">
            <h3 className="event-title">{card.title}</h3>
            <div
              className={`events-card ${hoveredCard === card.id ? "active" : ""}`}
              onMouseEnter={() => setHoveredCard(card.id)}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <img src={card.image} alt={card.title} />
              <div className="event-description">
                <p>{card.description}</p>
              </div>
            </div>
          </div>
        </SwiperSlide>
        
        ))}
      </Swiper>
    </section>
  );
};

export default EventsSection;
